import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { SidenavService } from '@shared/services/sidenav.service';
import { SidebarItem } from '@shared/sidebaritem';
import { sidebarItems } from './menu';

@Component({
	selector: 'app-admin',
	templateUrl: './admin.component.html',
	styleUrl: './admin.component.scss',
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class AdminComponent implements OnInit {
	sidebarItems: SidebarItem[] = sidebarItems;

	constructor(private sidenavService: SidenavService) {}

	ngOnInit(): void {
		this.sidenavService.setMenuData(this.sidebarItems);
		void this.sidenavService.closeRightPanel();
	}
}
